import { transformDataWithId } from "./transformDataWithId";

export const selectedFiltersFromQueryParams = (queryString, filterInfo) => {
  const filtersData = queryString.filter(
    (item) =>
      item.title.length > 0 &&
      item.value.length > 0 &&
      !item.title.startsWith("wc") &&
      !item.title.startsWith("sort_by") &&
      !item.title.startsWith("caliber") &&
      !item.title.startsWith("page"),
  );

  const processFiltersData = (filtersData, prefix) => {
    return filtersData
      .filter((item) => item.title.startsWith(prefix))
      .flatMap((item) => {
        if (prefix === "bw" || prefix === "rpb") {
          return item.value.split(",").map((val) => {
            const trimmedVal = val.trim();
            if (trimmedVal.includes("-")) {
              if (prefix === "bw") {
                const bwValues = trimmedVal.split("-");
                return {
                  title: item.title,
                  value: `${bwValues?.[0]} - ${bwValues?.[1]}`,
                  flag: trimmedVal,
                };
              }

              return {
                title: item.title,
                value: trimmedVal,
                flag: trimmedVal,
              };
            }

            if (prefix === "bw") {
              const filterRow = filterInfo?.["bullet_weight"]?.filter(
                (row) => row.alt_name === trimmedVal,
              );
              return {
                title: item.title,
                value: filterRow?.[0]?.name,
                flag: trimmedVal,
              };
            }
            return {
              title: item.title,
              value: trimmedVal,
              flag: trimmedVal,
            };
          });
        }
        return item.value.split(",").map((val) => ({
          title: item.title,
          value: val.trim(),
        }));
      });
  };

  const sf = processFiltersData(filtersData, "sf");
  const shell_length = processFiltersData(filtersData, "shell_length");
  const rpb = processFiltersData(filtersData, "rpb");
  const bw = processFiltersData(filtersData, "bw");
  const condition = processFiltersData(filtersData, "condition");

  // Extract keyword filters (s_in and s_out)
  const s_in = filtersData.find((item) => item.title === "s_in")?.value || "";
  const s_out = filtersData.find((item) => item.title === "s_out")?.value || "";
  // const bullet_type_s = processFiltersData(filtersData, "bullet_type_s");
  // const bt = processFiltersData(filtersData, "bt");
  // const mt = processFiltersData(filtersData, "mt");

  return (
    filterInfo && {
      sf,
      bullet_type_s: transformDataWithId(
        filterInfo,
        filtersData.filter((item) => item.title.startsWith("bullet_type_s")),
        "bullet_type_s",
        "name",
        "bullet_type_s",
        "id",
      ),
      bt: transformDataWithId(
        filterInfo,
        filtersData.filter((item) => item.title.startsWith("bt")),
        "bullet_type",
        "name",
        "bt",
        "id",
      ),
      shell_length: transformDataWithId(
        filterInfo,
        filtersData.filter((item) => item.title.startsWith("shell_length")),
        "shell_length",
        "name",
        "shell_length",
        "id",
      ),
      mt: transformDataWithId(
        filterInfo,
        filtersData.filter((item) => item.title.startsWith("mt")),
        "material",
        "name",
        "mt",
        "id",
      ),
      rpb,
      bw,
      condition,
      brnd: transformDataWithId(
        filterInfo,
        filtersData.filter((item) => item.title.startsWith("brnd")),
        "brand",
        "brand_name",
        "brnd",
        "brand_id",
      ),
      vid: transformDataWithId(
        filterInfo,
        filtersData.filter((item) => item.title.startsWith("vid")),
        "vendor_name",
        "vendor_name",
        "vid",
        "vendor_id",
      ),
      s_in,
      s_out,
    }
  );
};
